
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/note_v2/templates/edit"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='note-inputWrapper'>\n  <div class='controls-control btn upload_btn'>\n    <div class='note-uploadButtonRegion'></div>\n  </div>\n  <div class='mentionable_container'>\n    <div class='mentionable_wrapper'>\n      <ul class='mentionable_list'></ul>\n    </div>\n    <div class='mentionable_display'></div>\n    <textarea class='mentionable_comment input--text note-editInput' placeholder='Add your note…'></textarea>\n  </div>\n</div>\n";
},"useData":true});
    }).call(this);
  